module.exports = __webpack_public_path__ + "static/media/photo204.7cf7fc00.jpg";